import type { ClusterContributor } from '../../../shared/types';

export function firstZipcode(signaturesDistribution: readonly ClusterContributor[]) {
	const [first] = signaturesDistribution;
	if (!first) return [];
	return [
		{
			count: first.count,
			contributors: [{ ...first }],
			center: first.position,
		},
	];
}
